import { FormSectionWithRows } from '@strata/react-form-section';
import { InlineMessage } from '@strata/react-inline-message';
import {
    AddressDetailLabelValue,
    DetailLabel,
    DetailLabelList,
    DetailLabelValuePair,
} from '@strata/react-label-value-pairs';
import { ClaimStatusIndicator } from '@strata/react-status-indicators';

import { ClaimTotalsGridAndCodes } from 'components/claims/ClaimTotalsGridAndCodes';
import { ClaimPlaceOfServiceMap } from 'services/MedicalBillingConstants';
import {
    ClaimDetails as ClaimDetailsInterface,
    formatDiagnosisLabel,
} from 'store/api/medbillingApi';
import { DiagnosisCodeOption } from 'store/api/referenceApi';
import { SupplierDetails } from 'store/reference/referenceSlice';

interface ClaimDetailsProps {
    claimDetails?: ClaimDetailsInterface;
    supplierDetails?: SupplierDetails;
    diagnosesList?: DiagnosisCodeOption[];
}

export const ClaimDetails = ({
    claimDetails = undefined,
    supplierDetails = undefined,
    diagnosesList = undefined,
}: ClaimDetailsProps) => (
    <FormSectionWithRows
        sectionTitle="Claim Details"
        isLoading={!(claimDetails && supplierDetails)}
        rowOneContent={
            <>
                <AddressDetailLabelValue
                    style={{ width: '20%' }}
                    label="Pharmacy Billing Address"
                    address1={supplierDetails?.address1}
                    address2={supplierDetails?.address2}
                    city={supplierDetails?.city}
                    state={supplierDetails?.state}
                    zip={supplierDetails?.zip}
                />
                <DetailLabelValuePair
                    style={{ width: '20%' }}
                    label="Place Of Service"
                    value={
                        claimDetails?.placeOfService &&
                        ClaimPlaceOfServiceMap[claimDetails.placeOfService]
                    }
                />
                <DetailLabelList
                    style={{ width: '20%' }}
                    label="Additional Diagnoses"
                    values={claimDetails?.diagnoses
                        ?.slice(1)
                        ?.map((dx) => formatDiagnosisLabel(dx, diagnosesList))}
                />
                <DetailLabelValuePair
                    style={{ width: '20%' }}
                    label="Payer Claim ID"
                    value={claimDetails?.originalClaimNumber}
                />
                <DetailLabelValuePair
                    style={{ width: '20%' }}
                    label="FMH Claim ID"
                    value={claimDetails?.transactionId}
                />
            </>
        }
        rowTwoContent={
            <>
                <div style={{ width: '20%' }}>
                    <DetailLabel label="Status" />
                    <ClaimStatusIndicator status={claimDetails?.claimStatus} />
                </div>
                <DetailLabelList label="Status Codes" values={claimDetails?.claimStatusCodes} />
            </>
        }
        rowThreeContent={
            (claimDetails?.services ?? []).length > 0 && (
                <div style={{ width: '100%' }}>
                    <DetailLabel label="Claim Totals" />
                    {claimDetails?.payerId === 'HM001' && (
                        <div className="padding__bottom--medium">
                            <InlineMessage
                                intent={InlineMessage.Intent.INFO}
                                label="This claim was submitted in batch. Real-time adjustments are not available."
                            />
                        </div>
                    )}
                    <ClaimTotalsGridAndCodes claimData={claimDetails} showStatusCol />
                </div>
            )
        }
    />
);
